(function () {
    'use strict';

    angular
        .module('app')
        .factory('ActivityPermissionService', ActivityPermissionService);

    ActivityPermissionService.$inject = ['$http', '$q', 'UrlService'];

    function ActivityPermissionService($http, $q, UrlService) {
        var service = {
            getActivityPermissions: getActivityPermissions
        };

        return service;

        function getActivityPermissions() {
            return $http.get(UrlService.getWebAPIUrl() + '/activitypermission')
                .then(getActivityPermissionsOk, getActivityPermissionsError);

            function getActivityPermissionsOk(response) {
                return response.data;
            }

            function getActivityPermissionsError(response) {
                return $q.reject(response);
            }
        }
    }
})();